<template>
  <div class="menu-list-container" v-loading="loading">
    <div class="menu-list-body" v-if="!loading">
      <div class="menu-list-title">
        菜单管理<span>（拖动菜单名称进行排序，排序完成自动保存）</span>
      </div>
      <div class="menu-list-content">
        <div class="left">
          <div class="menu-search">
            <el-input placeholder="请输入菜单名称" prefix-icon="el-icon-search" v-model="filterText" clearable></el-input>
          </div>
          <div class="menu-list-content">
            <el-collapse v-model="activeItems">
              <el-collapse-item name="pc">
                <template slot="title">
                <span>
                  <i :class="getClass('pc')"></i>&nbsp;PC菜单
                </span>
                  <span @click.stop.prevent="addFirstMenu('pc', 0)" class="add-first-menu">
                  <b class="el-icon-plus"></b>添加一级菜单
                </span>
                </template>
                <menu-pc-tree ref="menuPcTree" :data="tree[0].children" @nodeClick="nodeClick" @handleDrop="handleDrop" @deleteActiveForm="deleteActiveForm"></menu-pc-tree>
              </el-collapse-item>
              <draggable-item
                v-for="item in draggableItems"
                :data="getItemData(item)"
                :key="item.type"
                @addFirstMenu="addFirstMenu"
                @menuClick="menuClick"
                @deleteMenu="deleteMenu"
                @updateArray="updateArray">
              </draggable-item>
            </el-collapse>
          </div>
        </div>
        <div class="right">
          <div class="right-content">
            <el-form ref="activeForm" :inline="true" label-width="98px" :model="activeForm" :hide-required-asterisk="true">
              <el-form-item label="名称" prop="data.name" :rules="{required: true, message: '请填写菜单名称'}">
                <el-input v-model="activeForm.data.name" :maxlength="20" :disabled="getDisable"></el-input>
              </el-form-item>
              <el-form-item label="链接" prop="data.link">
                <el-input v-model="activeForm.data.link" :disabled="getDisable"></el-input>
              </el-form-item>
              <el-form-item label="类型" prop="data.functionType" :rules="{required: true, message: '请选择类型'}">
                <el-select v-model="activeForm.data.functionType" :disabled="getDisable">
                  <el-option
                    v-for="item in getMenuTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="activeForm.module === 'pc'" class="select-parent" label="父级">
                <div class="parent-menu" :class="getDisable && 'disable-menu'" :title="activeForm.data.parentName" @click="openDialog">{{ activeForm.data.parentName || '请选择' }}</div>
              </el-form-item>
              <el-form-item
                class="upload-appIcon"
                v-if="activeForm.module === 'app' || activeForm.module === 'qywx'"
                label="菜单图标设置">
                <menu-upload-icon ref="menuUploadIcon" :data="activeForm.data.appModel" @uploadFile="uploadFile"></menu-upload-icon>
              </el-form-item>
              <div v-if="activeForm.module === 'app' || activeForm.module === 'qywx'">
                <el-form-item label="默认在工作台">
                  <el-checkbox v-model="activeForm.data.appModel.workbenchType"></el-checkbox>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="operation">
            <el-button :icon="saveIng ? 'el-icon-loading' : ''" :disabled="saveIng" type="primary" @click="saveMenu">保存</el-button>
          </div>
        </div>
      </div>
      <el-dialog
        title="请选择"
        class="select-parent-menu-dialog"
        v-if="parentSelect.visible"
        :visible.sync="parentSelect.visible"
        :close-on-click-modal="false"
        width="450px"
        center>
        <menu-select-parent-tree :data="tree[0].children" :activeId="activeForm.data.id" @closeDialog="closeDialog" @save="updatePosition"></menu-select-parent-tree>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import menuPcTree from './menu-pc-tree'
import menuSelectParentTree from './menu-select-parent-tree'
import menuUploadIcon from './menu-upload-icon'
import CookieOperation from '@/plugins/cookie'
import draggableItem from './draggable-item'
const menuTypes = [
  {
    value: '1',
    label: '菜单',
    module: 'pc'
  },
  {
    value: '3',
    label: '管理菜单',
    module: 'pc'
  },
  {
    value: '4',
    label: 'APP菜单',
    module: 'app'
  },
  {
    value: '6',
    label: '企业微信',
    module: 'qywx'
  },
  {
    value: '7',
    label: '功能点',
    module: 'function'
  }
]
export default {
  name: 'menuList',
  components: {menuPcTree, menuSelectParentTree, menuUploadIcon, draggableItem},
  data () {
    return {
      // 默认打开pc菜单
      activeItems: ['pc'],
      filterText: '',
      tree: [],
      activeForm: {
        // 在data中构建数据模型，要不然会导致props失效
        data: {
          name: '',
          id: '',
          link: '',
          type: '',
          parentId: '',
          parentName: '',
          functionType: '',
          appModel: {
            workbenchType: false,
            appIcon: ''
          }
        },
        // 默认是pc菜单
        module: 'pc',
        isSave: false
      },
      menuTypes,
      parentSelect: {
        visible: false
      },
      listItemActiveId: '',
      loading: true,
      draggableItems: [
        {type: 'app', title: 'APP模块'},
        {type: 'function', title: '功能点'},
        {type: 'qywx', title: '企业微信'}
      ],
      saveIng: false
    }
  },
  created () {
    this.getNodeList()
  },
  methods: {
    addFirstMenu (type, index) {
      // 判断当前下面是否有节点未保存，如果有直接切换即可
      let tree = this.$refs.menuPcTree
      let isNew = this.tree[index].children.find(c => c.isNew)
      if (isNew) {
        if (type === 'pc') {
          tree.setCurrentKey(isNew.id)
          this.nodeClick(isNew, '')
        } else {
          this.menuClick(isNew, type)
        }
      } else {
        let data = tree.getNewTree(this.tree[index])
        index !== -1 && this.tree[index].children.push({...data})
        // 选中当前节点
        this.$nextTick(() => {
          if (type === 'pc') {
            tree.setCurrentKey(data.id)
            this.nodeClick(data, '')
          } else {
            this.menuClick(data, type)
          }
          // 打开标签页
          if (this.activeItems.indexOf(type) === -1) {
            this.activeItems.push(type)
          }
        })
      }
    },
    // app、企业微信、功能点 删除
    deleteMenu (i, j, item) {
      this.$confirm('您确定要删除吗？', ' ', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'deleteMenuMessageBox',
        distinguishCancelAndClose: true,
        center: true
      }).then(res => {
        // 保存过后的菜单才需要走接口删除
        this.tree[j] && this.tree[j].children && this.tree[j].children.splice(i, 1)
        // 如果删除的是选中的则选中第一个
        if (this.tree[j] && this.tree[j].children.length) {
          this.activeForm.data.id === item.id && this.menuClick(this.tree[j].children[0])
        } else {
          // 如果模块的菜单全部被删除则，清空菜单
          this.deleteActiveForm()
        }
        !item.isNew && this.$axios.delete(`/auth-api/menus/${item.id}`).then(() => this.$message.success('删除成功!'))
      }).catch(() => {})
    },
    // app、企业微信、功能点 点击
    menuClick (item, module) {
      // 因为可能存在appModel不存在的请款
      if (!item.appModel) {
        item.appModel = {
          workbenchType: !!item.workbenchType,
          appIcon: item.icon || ''
        }
      }
      this.listItemActiveId = item.id
      this.activeForm.module = module
      this.activeForm.isSave = false
      let data = {...item}
      // 如果没有选中菜单类型，默认选中。
      if (!data.functionType) {
        data.functionType = this.menuTypes.find(c => c.module === module).value
      }
      this.activeForm.data = data
      // 清空树节点的选中
      let currentNode = this.$refs.menuPcTree.getCurrentNode()
      if (currentNode) {
        this.$refs.menuPcTree.$refs.tree.getNode(currentNode).isCurrent = false
      }
    },
    // 删除activeForm的数据
    deleteActiveForm () {
      this.activeForm = {
        data: {
          name: '',
          id: '',
          link: '',
          type: '',
          parentId: '',
          parentName: '',
          functionType: '',
          appModel: {
            workbenchType: false,
            appIcon: ''
          }
        },
        // 默认是pc菜单
        module: 'pc',
        isSave: false
      }
    },
    // pc菜单点击
    nodeClick (data, name) {
      this.listItemActiveId = ''
      this.activeForm.module = 'pc'
      this.activeForm.isSave = false
      this.activeForm.data = {...data}
      this.activeForm.data.parentName = name
    },
    saveMenu () {
      let module = this.activeForm.module
      if (module === 'app' && module === 'qywx' && this.$refs.menuUploadIcon.uploading) {
        return this.$message.error('图片正在上传中，请上传完之后操作！')
      }
      this.$refs.activeForm.validate(v => {
        if (v) {
          this.saveIng = true
          let params = this.getParams()
          // 保存之后需要重新排序。
          this.$axios.post('/auth-api/menus', params).then(res => {
            // 重新排序
            this.$message({
              type: 'success',
              message: '保存成功!'
            })
            this.disposeDataAndSort(params)
            this.$nextTick(() => { this.saveIng = false })
            // 保存之后是不会刷新数据的，需要将保存之后的数据覆盖原有的数据。
            if (this.activeForm.module === 'qywx' || this.activeForm.module === 'app') {
              this.activeForm.data.appModel = params.appModel
              let index = this.activeForm.module === 'app' ? 1 : 3
              let list = this.tree[index].children
              if (list && list.length) {
                let item = list.find(c => c.id === params.id)
                if (item) {
                  item.appModel = params.appModel
                }
              }
            }
          }).catch(() => { this.saveIng = false })
        }
      })
    },
    openDialog () {
      // 系统默认的一级菜单不可修改父级
      if (parseInt(this.activeForm.data.isBuiltIn) === 0) {
        this.parentSelect.visible = true
      }
    },
    closeDialog () {
      this.parentSelect.visible = false
    },
    // parentNode：获取勾选的节点，也就是当前选中节点的父节点
    updatePosition (parentData) {
      // 获取当前节点，删除当前节点
      let tree = this.$refs.menuPcTree
      let currentNode = tree.getNode(this.activeForm.data.id)
      if (currentNode) {
        tree.$refs.tree.remove(currentNode)
        let parentNode = tree.getNode(parentData.id)
        if (parentNode) {
          tree.$refs.tree.append(currentNode.data, parentNode)
          // 遍历展开当前节点的所有祖先节点。 直接给当前节点父节点设置expand=true不会展开其祖先节点。不知道为啥
          this.expandParentNode(parentNode)
          // 选中当前选中的key
          tree.setCurrentKey(this.activeForm.data.id)
          // 发送改变位置请求
          this.sendChangePosition(parentData)
          // 修改父节点的名称和parentId
          this.activeForm.data.parentId = parentNode.data.id
          this.activeForm.data.parentName = parentNode.data.name
        }
      }
      this.closeDialog()
    },
    getNodeList () {
      this.loading = true
      this.$axios.get('/auth-api/menus/treeMenu').then(res => {
        this.tree = res.data
        this.$nextTick(() => { this.loading = false })
      })
    },
    // 修改位置
    // 修改位置接口为异步走，不管失败还是成功，位置在前端是修改成功的
    sendChangePosition (parentNode, type = 1) {
      let params = {
        // 0/1  1：需要更新parentId
        type,
        parentId: parentNode.id || '',
        list: parentNode.children.map(m => m.id) || []
      }
      return this.$axios.post('/auth-api/menus/exchangeMenuSoft', params)
    },
    // 展开节点的祖先节点
    expandParentNode (node) {
      let level = node.level
      let expandNode = node
      while (--level >= 0) {
        if (expandNode) {
          expandNode.expanded = true
          expandNode = node.parent
        }
      }
    },
    uploadFile (url) {
      this.$set(this.activeForm.data.appModel, 'appIcon', url)
    },
    // 拖拽完成的时候触发
    async handleDrop (draggingNode, dropNode, dropType) {
      // 父节点变动时type 为 1，否则为0
      let type = 0
      if (dropType === 'inner') {
        // 如果是拖入到了目标节点内部，则父节点为目标节点，更新被拖拽节点的父节点id，name
        type = draggingNode.data.parentId === dropNode.data.id ? 0 : 1
        await this.sendChangePosition(dropNode.data, type)
        draggingNode.data.parentId = dropNode.data.id
        this.$set(this.activeForm.data, 'parentName', dropNode.data.name)
      } else {
        type = draggingNode.data.parentId === dropNode.data.parentId ? 0 : 1
        if (dropNode.level === 1) {
          await this.sendChangePosition(this.tree[0], type)
        } else {
          dropNode.parent && await this.sendChangePosition(dropNode.parent.data, type)
        }
        // 如果是拖入到了非目标节点内部，则父节点为目标节点的父节点
        draggingNode.data.parentId = dropNode.data.parentId || ''
        this.$set(this.activeForm.data, 'parentName', dropNode.parent.data.name)
      }
      // 更新当前激活的菜单的parentId
      this.activeForm.data.parentId = draggingNode.data.parentId
      // 层级嵌套太深，需要一次强制更新来渲染
      this.$forceUpdate()
    },
    // 右侧保存参数，直接merge，会导致数据有点问题
    getParams () {
      let node = this.$refs.menuPcTree.getNode(this.activeForm.data.id)
      // 功能点的level为2
      let level = this.activeForm.module === 'pc' ? node ? node.level : 1 : 1
      let appModel = this.getAppModule()
      return {
        name: this.activeForm.data.name,
        id: this.activeForm.data.id,
        link: this.activeForm.data.link,
        appModel,
        parentId: this.activeForm.data.parentId,
        functionType: this.activeForm.data.functionType,
        level: this.activeForm.module === 'function' ? 2 : level,
        workbenchType: appModel.workbenchType,
        icon: appModel.appIcon
      }
    },
    // 因为写到最后发现层级不一致，只能手动修改数据模型了。
    getAppModule () {
      if (this.activeForm.module === 'qywx' || this.activeForm.module === 'app') {
        let data = this.activeForm.data
        // app菜单修改，AppModel中的id不需要重新生成
        let id = (data.appModel && data.appModel.id) ? data.appModel.id : this.$refs.menuPcTree.getNewTree().id
        return {
          id,
          link: data.link,
          moduleName: data.name,
          relevanceId: data.id,
          relevanceType: 'menu',
          tenantId: CookieOperation.get('tenantId'),
          workbenchType: data.appModel.workbenchType,
          appIcon: data.appModel.appIcon
        }
      } else {
        return {}
      }
    },
    // 保存之后需要处理数据，和重新排序
    disposeDataAndSort (params) {
      if (this.activeForm.module === 'pc') {
        let node = this.$refs.menuPcTree.getNode(params.id)
        if (node) {
          let parentData = {}
          let item = {}
          if (node.level === 1) {
            parentData = this.tree[0]
            item = this.tree[0].children.find(c => c.id === params.id)
          } else {
            parentData = node.parent.data
            if (parentData) {
              item = parentData.children.find(c => c.id === params.id)
            }
          }
          if (item) {
            this.$_.assign(item, params)
            // 删除未保存状态
            item.isNew = false
          }
          this.$nextTick(() => this.sendChangePosition(parentData, 0))
        }
      } else {
        let index = this.getIndex(this.activeForm.module)
        let item = this.tree[index].children.find(c => c.id === params.id)
        if (item) {
          this.$_.assign(item, params)
          item.isNew = false
        }
        this.sendChangePosition(this.tree[index], 0)
      }
    },
    updateArray (index, list) {
      this.tree[index].children = list
      this.$nextTick(() => this.sendChangePosition(this.tree[index], 0))
    },
    getIndex (type) {
      switch (type) {
        case 'app':
          return 1
        case 'function':
          return 2
        case 'qywx':
          return 3
        default:
          return 0
      }
    }
  },
  computed: {
    getClass () {
      return name => this.activeItems.indexOf(name) === -1 ? 'el-icon-caret-right' : 'el-icon-caret-bottom'
    },
    getMenuTypes () {
      return this.menuTypes.filter(m => m.module === this.activeForm.module)
    },
    getItemData () {
      return item => {
        let index = this.getIndex(item.type)
        return {
          titleClass: this.getClass(item.type),
          type: item.type,
          filterText: this.filterText,
          listItemActiveId: this.listItemActiveId,
          list: this.tree[index].children || [],
          index,
          title: item.title
        }
      }
    },
    getDisable () {
      return parseInt(this.activeForm.data.isBuiltIn) === 1
    }
  },
  watch: {
    filterText (val) {
      this.$refs.menuPcTree.$refs.tree.filter(val)
    }
  }
}
</script>

<style lang="scss">
.menu-list-container {
  height: 100%;
  width: 100%;
  padding: 19px 20px 0 20px;
  box-sizing: border-box;
  background-color: #fff;
  .menu-list-body {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    .menu-list-title {
      height: 39px;
      font-size: 14px;
      color: #242424;
      & > span {
        color: #999898;
        font-size: 12px;
      }
    }
    .menu-list-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: calc(100% - 40px);
      & > .left {
        width: 422px;
        border-right: 1px solid #EDF2F5;
        height: 100%;
        .menu-search {
          padding: 0 20px 10px 0;
        }
        .menu-list-content {
          overflow: auto;
          .el-collapse {
            height: 100%;
            border: none;
            width: 100%;
            .el-collapse-item {
              .el-collapse-item__header, .el-collapse-item__wrap {
                border: none;
              }
              .el-collapse-item__header {
                border-bottom: 1px solid #EDF2F5;
                outline: none;
                user-select: none;
                position: relative;
                height: 46px;
                line-height: 46px;
                .el-collapse-item__arrow {
                  display: none;
                }
                span {
                  font-size: 14px;
                  color: #242424;
                  i {
                    color: #C2C3C4;
                  }
                }
                .add-first-menu {
                  position: absolute;
                  right: 20px;
                  color: #242424;
                  font-size: 12px;
                  .el-icon-plus {
                    margin-right: 4px;
                    color: #242424;
                    font-weight: 800;
                    font-size: 10px;
                  }
                  &:hover {
                    color: var(--shade-1, #409EFF);
                    .el-icon-plus {
                      color: var(--shade-1, #409EFF);
                    }
                  }
                  &:active {
                    color: var(--shade-2, #388DD2);
                    .el-icon-plus {
                      color: var(--shade-2, #388DD2);
                    }
                  }
                }
              }
              .el-collapse-item__wrap {
                .el-collapse-item__content {
                  padding: 0 20px;
                  height: 100%;
                  min-width: 100%;
                  overflow: auto;
                  .list-item {
                    height: 39px;
                    line-height: 39px;
                    cursor: pointer;
                    border-bottom: 1px solid #EDF2F5;
                    color: #242424;
                    display: flex;
                    align-items: center;
                    .item-name {
                      width: calc(100% - 30px);
                      display: inline-block;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }
                    .el-icon-delete {
                      display: none;
                      color: #C2C3C4;
                      &:hover {
                        color: #fb9391;
                      }
                      &:active {
                        color: red;
                      }
                    }
                    &:hover {
                      background-color: #F5F7FA;
                      .el-icon-delete {
                        display: inline-block;
                      }
                    }
                  }
                  .active-item {
                    color: var(--primary, #54ABF1);
                    .el-icon-delete {
                      display: inline-block;
                    }
                  }
                  .sortable-ghost {
                    border-bottom: 1px solid var(--shade-1, #409EFF);
                  }
                }
              }
            }
          }
        }
        .el-collapse-item:last-child {
          margin-bottom: 0;
        }
      }
      & > .right {
        width: calc(100% - 425px);
        height: 100%;
        .right-content {
          max-width: 745px;
          margin: 0 auto;
          .el-form {
            .el-form-item {
              .el-form-item__content {
                .el-input {
                  width: 238px;
                  .el-input__inner {
                    width: 238px;
                  }
                }
              }
            }
            .select-parent {
              .el-form-item__content {
                padding-left: 11px;
                .parent-menu {
                  width: 200px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  color: var(--primary, #409eff);
                  cursor: pointer;
                }
                .disable-menu {
                  color: #ccc;
                }
              }
            }
            .upload-appIcon {
              height: 44px;
              .el-form-item__content {
                width: 238px;
              }
              .el-form-item__label {
                height: 44px;
              }
            }
          }
        }
        .operation {
          text-align: center;
          padding-top: 100px;
          .el-button {
            width: 82px;
            height: 26px;
            border-radius: 3px;
            padding: 0;
          }
        }
      }
    }
  }
}
.select-parent-menu-dialog {
  .el-dialog {
    .el-dialog__body {
      padding: 13px 19px 0 18px;
    }
  }
}
.el-message-box__wrapper {
  .deleteMenuMessageBox {
    width: 400px;
    height: 172px;
    background: #FFFFFF;
    box-shadow: 0 2px 8px 1px rgba(170, 174, 181, 0.42);
    border-radius: 4px;
    padding-bottom: 0;
    .el-message-box__content {
      padding: 5px 15px 0 15px;
      height: calc(100% - 100px);
      color: #2C2C2C;
    }
    .el-message-box__btns {
      .el-button {
        width: 82px;
        height: 26px;
        border-radius: 4px;
        padding: 0;
        background: var(--primary, #409eff);
        border: 1px solid var(--primary, #409eff);
        color: #fff;
        &:hover {
          color: #fff;
          background-color: var(--light-2, #54abf2);
          border-color: var(--light-2, #54abf2);
        }
      }
      .el-button + .el-button {
        margin-left: 50px;
        border: 1px solid #E5E8ED;
        background-color: #fff;
        color: #2A2929;
        &:hover {
          color: var(--light-2, #54abf2);
          border-color: var(--light-5, #c6e2ff);
          background-color: var(--light-8, #ecf5ff);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/system/menu/menu-list.vue